<template>
  <div>
    <tabs :value="tabs" type="card" @on-click="handleTabClick">
      <tab-pane label="策略模板" name="tag_template">
        <modal
          v-model="bindHostSelectCounterModal"
          width="800"
          title="选择指标">
          <Select filterable @on-change="bindHostSelectCounterChange" not-found-text="请先绑定有指标的设备组">
            <Option v-for="item in bindHostSelectCounterData" :value="item.counter" :key="item.counter" :label="item.describe + ' ' + item.counter"></Option>
          </Select>
          <div slot="footer"></div>
        </modal>
        <modal
          v-model="templateHaveHostGroupModal"
          width="1000"
          scrollable
          :closable="false"
          :title="templateHaveHostGroupModalTitle"
          @on-ok="templateHaveHostGroupModalOk"
          @on-cancel="templateHaveHostGroupModalCancel">
          <div>
            <transfer
              filterable
              :list-style="listStyle"
              :data="templateHaveHostGroupData"
              :target-keys="templateHaveHostGroupTargetKeys"
              @on-change="templateHaveHostGroupChange">
            </transfer>
          </div>
        </modal>
        <modal
          v-model="templateFormIsShow"
          width="600"
          scrollable
          :closable="false"
          :title="templateFormTitle">
          <i-form ref="templateForm" :model="templateForm" :rules="templateRule" :label-width="60">
            <form-item label="名称" prop="name">
              <i-input v-model="templateForm.name"></i-input>
            </form-item>
            <FormItem label="父模板" prop="parent_id">
              <i-select v-model="templateForm.parent_id" clearable>
                <i-option v-for="item in templateAllList" :value="item.template.id" :key="item.template.id" :label="item.template.tpl_name"></i-option>
              </i-select>
              <Alert show-icon style="margin-top: 8px">
                <span>
                  <p>子模板将继承父模板的策略。</p>
                  <p>在子模板中添加父模板已有的策略指标，可覆盖父模板的策略。</p>
                </span>
              </Alert>
            </FormItem>
          </i-form>
          <div slot="footer">
            <i-button @click="templateFormShow(false)" style="margin-left: 8px">取消</i-button>
            <i-button type="primary" @click="templateSubmit('templateForm')">提交</i-button>
          </div>
        </modal>
        <modal
          v-model="templateActionIsShow"
          width="600"
          scrollable
          :closable="false"
          :title="templateActionTitle">
          <i-form ref="templateActionForm" :model="templateActionForm" :label-width="80">
            <form-item label="告警接收组" prop="uic">
              <i-select v-model="templateActionForm.uic" multiple>
                <i-option v-for="item in AllUserGroupList" :value="item.team.name" :key="item.team.name" :label="item.team.name"></i-option>
              </i-select>
            </form-item>
            <form-item label="回调模式" prop="callback">
              <i-switch v-model="templateActionForm.callback">
                <span slot="open">开</span>
                <span slot="close">关</span>
              </i-switch>
              <tooltip placement="bottom">
                <i-button type="text" :style="{paddingLeft: 0}"><Icon type="ios-help-circle-outline" size="18" /></i-button>
                <div slot="content">
                  <p>高级用法, 配置了回调地址才会触发回调</p>
                </div>
              </tooltip>
            </form-item>
            <div v-show="templateActionForm.callback">
              <form-item label="回调地址" prop="url">
                <i-input v-model="templateActionForm.url" style="width: 90%"></i-input>
                <tooltip placement="bottom">
                  <i-button type="text" :style="{paddingLeft: 0}"><Icon type="ios-help-circle-outline" size="18" /></i-button>
                  <div slot="content">
                    <p>只支持 http get 方式回调</p>
                  </div>
                </tooltip>
              </form-item>
              <!--<form-item label="回调之前发提醒短信" :label-width="135">-->
                <!--<i-switch v-model="templateActionForm.before_callback_sms">-->
                  <!--<span slot="open">是</span>-->
                  <!--<span slot="close">否</span>-->
                <!--</i-switch>-->
              <!--</form-item>-->
              <!--<form-item label="回调之前发提醒邮件" :label-width="135">-->
                <!--<i-switch v-model="templateActionForm.before_callback_mail">-->
                  <!--<span slot="open">是</span>-->
                  <!--<span slot="close">否</span>-->
                <!--</i-switch>-->
              <!--</form-item>-->
              <!--<form-item label="回调之后发结果短信" :label-width="135">-->
                <!--<i-switch v-model="templateActionForm.after_callback_sms">-->
                  <!--<span slot="open">是</span>-->
                  <!--<span slot="close">否</span>-->
                <!--</i-switch>-->
              <!--</form-item>-->
              <!--<form-item label="回调之后发结果邮件" :label-width="135">-->
                <!--<i-switch v-model="templateActionForm.after_callback_mail">-->
                  <!--<span slot="open">是</span>-->
                  <!--<span slot="close">否</span>-->
                <!--</i-switch>-->
              <!--</form-item>-->
            </div>
          </i-form>
          <div slot="footer">
            <i-button @click="templateActionShow(false)" style="margin-left: 8px">取消</i-button>
            <i-button type="primary" @click="templateActionSubmit('templateActionForm')">提交</i-button>
          </div>
        </modal>
        <modal
          v-model="templateStrategyFormIsShow"
          width="600"
          scrollable
          :closable="false"
          :title="templateStrategyTitle">
          <Form ref="templateStrategyForm" inline :model="templateStrategyForm" :rules="templateStrategyRule" :label-width="95">
            <FormItem label="指标" prop="metric" class="w-100">
              <Select filterable v-model="templateStrategyForm.metric" not-found-text="请先绑定有指标的设备">
                <Option v-for="item in bindHostSelectCounterData" :value="item.counter" :key="item.counter" :label="item.describe + ' ' + item.counter"></Option>
              </Select>
              <!--<Input v-model="templateStrategyForm.metric" :style="{width: '390px'}" :readonly="true" placeholder=""/>-->
              <!--<Button type="text" size="small" :style="{color: '#2d8cf0'}" @click="bindHostSelectCounterModalOpen">点击选择</Button>-->
            </FormItem>
            <form-item label="标签" prop="tags">
              <i-input v-model="templateStrategyForm.tags"></i-input>
            </form-item>
            <form-item label="最大报警次数" prop="max_step">
              <i-input v-model="templateStrategyForm.max_step" number></i-input>
            </form-item>
            <form-item label="告警方式" prop="alarm_style">
              <CheckboxGroup v-model="alarm_style">
                <Checkbox :label="1">邮件</Checkbox>
                <Checkbox :label="3">IM</Checkbox>
                <Checkbox :label="5">短信</Checkbox>
                <Checkbox :label="11">电话</Checkbox>
              </CheckboxGroup>
            </form-item>
            <row class="mob-w-auto">
              <form-item label="触发条件" prop="func">
                <i-input v-model="templateStrategyForm.func" :style="{width: '100px'}"></i-input>
              </form-item>
              <form-item prop="op" :label-width="0">
                <i-select v-model="templateStrategyForm.op" :style="{width: '50px'}">
                  <i-option v-for="item in funcOpList" :value="item" :key="item" :label="item"></i-option>
                </i-select>
              </form-item>
              <form-item prop="right_value" :label-width="0">
                <i-input v-model="templateStrategyForm.right_value" :style="{width: '100px'}"></i-input>
              </form-item>
              <tooltip max-width="500" placement="bottom">
                <i-button type="text" :style="{paddingLeft: 0}"><Icon type="ios-help-circle-outline" size="18" /></i-button>
                <div slot="content">
                  <p>配置报警策略的时候支持多种报警触发函数，比如all(#3) diff(#10)等等，这些#后面的数字表示的是最新的历史点。比如#3代表的是最新的三个点。</p>
                  <p>all(#3): 最新的3个点都满足阈值条件则报警</p>
                  <p>max(#3): 对于最新的3个点，其最大值满足阈值条件则报警</p>
                  <p>min(#3): 对于最新的3个点，其最小值满足阈值条件则报警</p>
                  <p>sum(#3): 对于最新的3个点，其和满足阈值条件则报警</p>
                  <p>avg(#3): 对于最新的3个点，其平均值满足阈值条件则报警</p>
                  <p>diff(#3): 拿最新push上来的点（被减数），与历史最新的3个点（3个减数）相减，得到3个差，只要有一个差满足阈值条件则报警</p>
                  <p>pdiff(#3): 拿最新push上来的点，与历史最新的3个点相减，得到3个差，再将3个差值分别除以减数，得到3个商值，只要有一个商值满足阈值则报警</p>
                  <p>lookup(#2,3): 最新的3个点中有2个满足条件则报警</p>
                </div>
              </tooltip>
            </row>
            <form-item label="全天发送" prop="allTime">
              <i-switch v-model="alarmIsAllTime">
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
            </form-item>
            <form-item label="告警星期" prop="alarm_week" v-if="!alarmIsAllTime">
              <CheckboxGroup v-model="templateStrategyForm.alarm_week">
                <Checkbox label="1">周一</Checkbox>
                <Checkbox label="2">周二</Checkbox>
                <Checkbox label="3">周三</Checkbox>
                <Checkbox label="4">周四</Checkbox>
                <Checkbox label="5">周五</Checkbox>
                <Checkbox label="6">周六</Checkbox>
                <Checkbox label="7">周日</Checkbox>
              </CheckboxGroup>
            </form-item>
            <row v-if="!alarmIsAllTime">
              <form-item label="告警开始时间" prop="run_begin">
                <time-picker format="HH:mm" :style="{width: '150px'}" v-model="templateStrategyForm.run_begin"></time-picker>
              </form-item>
              <form-item label="告警结束时间" prop="run_end">
                <time-picker format="HH:mm" :style="{width: '150px'}" v-model="templateStrategyForm.run_end"></time-picker>
              </form-item>
            </row>
            <form-item label="告警附加信息" prop="note">
              <i-input v-model="templateStrategyForm.note" placeholder="随告警消息发送"></i-input>
            </form-item>
            <form-item label="激活" prop="is_active">
              <i-switch v-model="templateStrategyForm.is_active">
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
            </form-item>
          </Form>
          <div slot="footer">
            <i-button @click="templateStrategyFormShow(false)" style="margin-left: 8px">取消</i-button>
            <i-button type="primary" :loading="strategySubmitting" @click="templateStrategySubmit('templateStrategyForm')">提交</i-button>
          </div>
        </modal>
        <modal
          v-model="templateStrategyListIsShow"
          width="1200"
          scrollable
          :title="'[' + templateStrategyListTitle + '] 策略列表'">
          <row :style="{marginBottom: '5px'}">
            <i-button type="primary" size="small" :style="{float: 'right'}" @click="templateStrategyFormShow(true)">添加策略</i-button>
          </row>
          <i-table name="templateStrategyListTable" border :columns="templateStrategyList.columns" size="small" :data="templateStrategyList.data"></i-table>

          <div v-if="inheritTemplateList.data.length > 0">
            <br />
            <Row>
              <Col>
                <Divider orientation="left">父模板</Divider>
                <i-table name="inheritTemplateTable" border :columns="inheritTemplateList.columns" size="small" :data="inheritTemplateList.data"></i-table>
              </Col>
            </Row>
          </div>
          <div slot="footer">
          </div>
        </modal>
        <Card shadow>
          <i-input v-model="template.query" @on-change="v=>{ getTemplates(1)}" icon="ios-search" placeholder="过滤" style="width: 200px; margin-bottom: 10px;"></i-input>
          <i-button type="primary" @click="templateFormShow(true)" :style="{float: 'right'}" v-show="!templateFormIsShow" icon="md-add">添加</i-button>
          <i-table name="templateTable" border :columns="template.columns" size="small" :data="template.data"></i-table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page :total="template.total" :current="template.current_page" :page-size="template.limit" @on-change="getTemplates"></page>
            </div>
          </div>
        </Card>
      </tab-pane>
      <tab-pane label="设备组" name="tag_hostgroup">
        <modal
          v-model="hostGroupHaveHostModal"
          width="1000"
          scrollable
          :closable="false"
          :title="hostGroupHaveHostModalTitle"
          @on-ok="hostGroupHaveHostModalOk"
          @on-cancel="hostGroupHaveHostModalCancel">
          <div>
            <transfer
              filterable
              :list-style="listStyle"
              :data="hostGroupHaveHostData"
              :target-keys="hostGroupHaveHostTargetKeys"
              @on-change="hostGroupHaveHostChange">
            </transfer>
          </div>
        </modal>
        <modal
          v-model="hostGroupFormIsShow"
          width="600"
          scrollable
          :closable="false"
          :title="hostGroupFormTitle">
          <i-form ref="hostGroupForm" :model="hostGroupForm" :rules="hostGroupRule" :label-width="80">
            <form-item label="名称" prop="name">
              <i-input v-model="hostGroupForm.name"></i-input>
            </form-item>
          </i-form>
          <div slot="footer">
            <i-button @click="hostGroupFormShow(false)" style="margin-left: 8px">取消</i-button>
            <i-button type="primary" @click="hostGroupSubmit('hostGroupForm')">提交</i-button>
          </div>
        </modal>
        <!--<row v-show="hostGroupFormIsShow">-->
          <!--<divider>{{ hostGroupFormTitle }}</divider>-->
          <!--<i-col offset="9" span="6">-->
            <!--<i-form ref="hostGroupForm" :model="hostGroupForm" :rules="hostGroupRule" :label-width="80">-->
              <!--<form-item label="名称" prop="name">-->
                <!--<i-input v-model="hostGroupForm.name"></i-input>-->
              <!--</form-item>-->
              <!--<form-item>-->
                <!--<i-button type="primary" @click="hostGroupSubmit('hostGroupForm')">提交</i-button>-->
                <!--<i-button @click="hostGroupFormShow(false)" style="margin-left: 8px">取消</i-button>-->
              <!--</form-item>-->
            <!--</i-form>-->
          <!--</i-col>-->
        <!--</row>-->
        <Card shadow>
          <row>
            <i-select v-model="hostGroupBelongTemplate" :transfer="true" @on-change="getHostGroups" clearable style="width: 200px; margin-bottom: 10px; margin-right: 5px;" placeholder="策略模板">
              <i-option v-for="item in templateAllList" :value="item.template.id" :key="item.template.id" :label="item.template.tpl_name"></i-option>
            </i-select>
            <i-input v-model="hostGroup.query" v-show="!hostGroupBelongTemplate" @on-change="v=>{ getHostGroups(1)}" icon="ios-search" placeholder="过滤" style="width: 200px; margin-bottom: 10px;"></i-input>
            <i-button type="primary" :style="{float: 'right'}" @click="hostGroupFormShow(true)" v-show="!hostGroupFormIsShow" icon="md-add">添加</i-button>
          </row>
          <i-table name="hostGroupTable" border :columns="hostGroup.columns" size="small" :data="hostGroup.data"></i-table>
        </Card>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: right;">
            <page :total="hostGroup.total" :current="hostGroup.current_page" :page-size="hostGroup.limit" @on-change="getHostGroups"></page>
          </div>
        </div>
      </tab-pane>
      <tab-pane label="用户组" name="tag_usergroup">
        <modal
          v-model="userGroupFormIsShow"
          width="600"
          scrollable
          :closable="false"
          :title="userGroupFormTitle">
          <i-form ref="userGroupForm" :model="userGroupForm" :rules="userGroupRule" :label-width="80">
            <form-item label="名称" prop="name">
              <i-input v-model="userGroupForm.name"></i-input>
            </form-item>
            <form-item label="备注" prop="resume">
              <i-input v-model="userGroupForm.resume"></i-input>
            </form-item>
            <form-item label="告警用户" prop="users">
              <i-select v-model="userGroupForm.users" multiple clearable filterable>
                <i-option v-for="item in AllUsersList" :value="item.id" :key="item.id" :label="item.name"></i-option>
              </i-select>
            </form-item>
          </i-form>
          <div slot="footer">
            <i-button @click="userGroupFormShow(false)" style="margin-left: 8px">取消</i-button>
            <i-button type="primary" @click="userGroupSubmit('userGroupForm')">提交</i-button>
          </div>
        </modal>
        <!--<row v-show="userGroupFormIsShow">-->
          <!--<divider>{{ userGroupFormTitle }}</divider>-->
          <!--<i-col offset="9" span="6">-->
            <!--<i-form ref="userGroupForm" :model="userGroupForm" :rules="userGroupRule" :label-width="80">-->
              <!--<form-item label="名称" prop="name">-->
                <!--<i-input v-model="userGroupForm.name"></i-input>-->
              <!--</form-item>-->
              <!--<form-item label="备注" prop="resume">-->
                <!--<i-input v-model="userGroupForm.resume"></i-input>-->
              <!--</form-item>-->
              <!--<form-item label="告警用户" prop="users">-->
                <!--<i-select v-model="userGroupForm.users" multiple clearable>-->
                  <!--<i-option v-for="item in AllUsersList" :value="item.id" :key="item.id" :label="item.name"></i-option>-->
                <!--</i-select>-->
              <!--</form-item>-->
              <!--<form-item>-->
                <!--<i-button type="primary" @click="userGroupSubmit('userGroupForm')">提交</i-button>-->
                <!--<i-button @click="userGroupFormShow(false)" style="margin-left: 8px">取消</i-button>-->
              <!--</form-item>-->
            <!--</i-form>-->
          <!--</i-col>-->
        <!--</row>-->
        <Card shadow>
          <i-input v-model="userGroup.query" @on-change="v=>{ getUserGroups(1)}" icon="ios-search" placeholder="过滤" style="width: 200px; margin-bottom: 10px;"></i-input>
          <i-button type="primary" :style="{float: 'right'}" @click="userGroupFormShow(true)" v-show="!userGroupFormIsShow" icon="md-add">添加</i-button>
          <i-table name="userGroupTable" border :columns="userGroup.columns" size="small" :data="userGroup.data"></i-table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page :total="userGroup.total" :current="userGroup.current_page" :page-size="userGroup.limit" @on-change="getUserGroups"></page>
            </div>
          </div>
        </Card>
      </tab-pane>
      <tab-pane label="个人告警信息" name="tag_personal_info">
        <Card shadow>
          <row :style="{marginTop: '20px'}">
            <i-col span="24" :md="{span:16,offset:4}" :xl="{span:8,offset:8}">
              <i-form ref="personalInfoForm" :model="personalInfoForm" :rules="personalInfoRule" :label-width="80">
                <form-item label="邮箱" prop="email">
                  <i-input v-model="personalInfoForm.email" :style="{width: '90%'}"></i-input>
                </form-item>
                <form-item label="手机" prop="phone">
                  <i-input v-model="personalInfoForm.phone" :style="{width: '90%'}"></i-input>
                </form-item>
                <form-item label="IM" prop="im">
                  <i-input v-model="personalInfoForm.im" :style="{width: '90%'}"></i-input>
                  <tooltip placement="bottom">
                    <i-button type="text" :style="{paddingLeft: 0}"><Icon type="ios-help-circle-outline" size="18" /></i-button>
                    <div slot="content">
                      <p>内部通讯工具账号，如微信、钉钉</p>
                    </div>
                  </tooltip>
                </form-item>
                <form-item>
                  <i-button type="primary" @click="personalInfoSubmit('personalInfoForm')">保存</i-button>
                  <i-button @click="getPersonalInfo" style="margin-left: 8px">重置</i-button>
                </form-item>
              </i-form>
            </i-col>
          </row>
        </Card>
      </tab-pane>
    </tabs>
  </div>
</template>

<script>
import * as mainRequest from '@/api/monitor'
let trueOrFalseTransform = { 1: true, 0: false }
export default {
  name: 'alarm',
  data () {
    return {
      my_theme: 'dark',
      spinShow: false,
      tabs: 'tag_template',
      listStyle: {
        width: '450px',
        height: '300px'
      },

      // 策略模板
      templateAllList: [],
      templateFormIsShow: false,
      templateFormTitle: '',
      templateForm: {
        id: 0,
        name: '',
        parent_id: 0
      },
      templateRule: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      },
      templateAlarmUserGroupModal: false,
      template: {
        query: '',
        total: 1,
        limit: 15,
        current_page: 1,
        data: [],
        columns: [
          {
            title: '名称',
            align: 'center',
            minWidth: 200,
            render: (h, params) => {
              return h('div', params.row.template.tpl_name)
            }
          },
          {
            title: '父模板',
            key: 'parent_name',
            align: 'center',
            minWidth: 80
          },
          {
            title: '创建用户',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              return h('div', params.row.template.create_user)
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 350,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    title: '策略列表'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.templateStrategyListShow(true, params.row)
                    }
                  }
                }, '策略列表'),
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                    title: '告警动作'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.templateActionShow(true, params.row)
                    }
                  }
                }, '告警动作'),
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small',
                    title: '绑定设备组'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.templateHaveHostGroup(params.row.template)
                    }
                  }
                }, '绑定设备组'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small',
                    title: '修改'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.templateFormShow(true, params.row.template)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    title: '删除'
                  },
                  on: {
                    click: () => {
                      this.templateRemove(params.row.template)
                    }
                  }
                }, '删除')
              ])
            }
          }
        ]
      },
      alarmIsAllTime: true,
      bindHostSelectCounterModal: false,
      bindHostSelectCounterData: [],
      inheritTemplateList: {
        data: [],
        columns: [
          {
            title: '名称',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              return h('div', params.row.template.tpl_name)
            }
          },
          {
            title: '父模板',
            key: 'parent_name',
            align: 'center',
            minWidth: 80
          },
          {
            title: '创建用户',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              return h('div', params.row.template.create_user)
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 350,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    title: '策略列表'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.templateStrategyListShow(true, params.row)
                    }
                  }
                }, '策略列表')
              ])
            }
          }
        ]
      },
      showParentTemplateId: '',
      alarm_style: [],

      // 策略模板 -- 策略列表
      templateStrategyListTitle: '策略列表',
      templateStrategyTitle: '添加策略',
      templateStrategyListIsShow: false,
      templateStrategyFormIsShow: false,
      strategySubmitting: false,
      templateStrategyList: {
        data: [],
        columns: [
          {
            title: 'ID',
            align: 'center',
            minWidth: 60,
            key: 'id'
          },
          {
            title: '指标',
            align: 'center',
            minWidth: 110,
            key: 'metric'
          },
          {
            title: '标签(tags)',
            align: 'center',
            minWidth: 100,
            key: 'tags'
          },
          {
            title: '最大告警次数',
            align: 'center',
            minWidth: 110,
            key: 'max_step'
          },
          {
            title: '告警方式',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              let re = []
              let priority = params.row.priority
              if (priority === 1) {
                re.push(h('Tag', '邮件'))
              } else if (priority === 3) {
                re.push(h('Tag', 'IM'))
              } else if (priority === 5) {
                re.push(h('Tag', '短信'))
              } else if (priority === 4) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', 'IM'))
              } else if (priority === 6) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', '短信'))
              } else if (priority === 8) {
                re.push(h('Tag', 'IM'))
                re.push(h('Tag', '短信'))
              } else if (priority === 9) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', 'IM'))
                re.push(h('Tag', '短信'))
              } else if (priority === 12) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', '电话'))
              } else if (priority === 14) {
                re.push(h('Tag', 'IM'))
                re.push(h('Tag', '电话'))
              } else if (priority === 15) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', 'IM'))
                re.push(h('Tag', '电话'))
              } else if (priority === 16) {
                re.push(h('Tag', '电话'))
                re.push(h('Tag', '短信'))
              } else if (priority === 17) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', '短信'))
                re.push(h('Tag', '电话'))
              } else if (priority === 19) {
                re.push(h('Tag', 'IM'))
                re.push(h('Tag', '短信'))
                re.push(h('Tag', '电话'))
              } else if (priority === 20) {
                re.push(h('Tag', '邮件'))
                re.push(h('Tag', 'IM'))
                re.push(h('Tag', '短信'))
                re.push(h('Tag', '电话'))
              }
              return h('div', re)
            }
          },
          {
            title: '触发条件',
            align: 'center',
            minWidth: 110,
            render: (h, params) => {
              return h('div', params.row.func + ' ' + params.row.op + ' ' + params.row.right_value)
            }
          },
          {
            title: '说明',
            align: 'center',
            minWidth: 80,
            key: 'note'
          },
          {
            title: '报警开始时间',
            align: 'center',
            minWidth: 110,
            key: 'run_begin'
          },
          {
            title: '报警结束时间',
            align: 'center',
            minWidth: 110,
            key: 'run_end'
          },
          {
            title: '状态',
            align: 'center',
            key: 'is_active',
            minWidth: 100,
            render: (h, params) => {
              let isActive = params.row.is_active
              let type = 'red'
              let aText = '已暂停'
              if (isActive) {
                type = 'blue'
                aText = '已生效'
              }
              return h('Tag', {
                props: {
                  color: type
                }
              }, aText)
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 200,
            render: (h, params) => {
              let isActive = params.row.is_active
              let type = 'error'
              let aText = '暂停'
              let targetStatus = false
              let iconType = 'md-pause'
              if (!isActive) {
                type = 'success'
                aText = '激活'
                targetStatus = true
                iconType = 'md-play'
              }
              return h('div', [
                h('Button', {
                  props: {
                    type: type,
                    size: 'small',
                    ghost: true,
                    icon: iconType,
                    loading: this.activeStrategyLoading
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.activeStrategyAction(targetStatus, params.row.id)
                    }
                  }
                }, aText),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small',
                    title: '编辑'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.templateStrategyFormShow(true, params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    title: '删除'
                  },
                  on: {
                    click: () => {
                      this.templateStrategyRemove(params.row)
                    }
                  }
                }, '删除')
              ])
            }
          }
        ]
      },
      templateStrategyForm: {
        id: 0,
        tpl_id: 0,
        metric: '',
        tags: '',
        max_step: 3,
        priority: 0,
        note: '',
        func: 'all(#3)',
        op: '==',
        right_value: '0',
        run_begin: '',
        run_end: '',
        alarm_week: ['1', '2', '3', '4', '5', '6', '7'],
        is_active: true
      },
      templateStrategyRule: {
        metric: [
          { required: true, message: '指标不能为空', trigger: 'blur' }
        ],
        max_step: [
          { required: true, type: 'number', message: '最大报警次数不能为空, 必须为数字类型', trigger: 'blur' }
        ],
        priority: [
          { required: true, type: 'number', message: '报警等级不能为空, 必须为数字类型', trigger: 'blur' }
        ],
        func: [
          { required: true, message: '触发函数不能为空', trigger: 'blur' }
        ],
        op: [
          { required: true, message: '触发函数符号不能为空', trigger: 'blur' }
        ],
        right_value: [
          { required: true, message: '触发阈值不能为空', trigger: 'blur' }
        ]
      },
      metricDefaultList: [],
      funcOpList: ['==', '!=', '<', '<=', '>', '>='],
      activeStrategyLoading: false,

      // 策略模板 -- 告警动作
      AllUserGroupList: [],
      templateActionIsShow: false,
      templateActionTitle: '告警动作',
      templateActionForm: {
        id: 0,
        tpl_id: 0,
        uic: [],
        callback: false,
        url: '',
        before_callback_sms: false,
        before_callback_mail: false,
        after_callback_sms: false,
        after_callback_mail: false
      },

      // 策略模板 -- 绑定设备组
      templateHaveHostGroupModal: false,
      templateHaveHostGroupModalTitle: '绑定设备组',
      templateHaveHostGroupData: [],
      templateHaveHostGroupTargetKeys: [],
      templateHaveHostGroupTplId: 0,

      // 告警设备组
      hostGroupFormIsShow: false,
      hostGroupFormTitle: '',
      hostGroupForm: {
        id: 0,
        name: ''
      },
      hostGroupRule: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      },
      hostGroupBelongTemplate: 0,
      hostGroup: {
        query: '',
        total: 1,
        limit: 15,
        current_page: 1,
        data: [],
        columns: [
          {
            title: '名称',
            key: 'grp_name',
            align: 'center',
            minWidth: 110
          },
          {
            title: '创建用户',
            key: 'create_user',
            align: 'center',
            minWidth: 100
          },
          {
            title: '操作',
            minWidth: 200,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.getHostsByHostGroupId(params.row)
                    }
                  }
                }, '绑定设备'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.hostGroupFormShow(true, params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.hostGroupRemove(params.row)
                    }
                  }
                }, '删除')
              ])
            }
          }
        ]
      },

      // 告警设备组 -- 绑定设备
      hostGroupHaveHostModal: false,
      hostGroupHaveHostModalTitle: '绑定设备',
      hostGroupHaveHostData: [],
      hostGroupHaveHostTargetKeys: [],
      hostGroupHaveHostHGId: 0,

      // 告警用户组
      userGroupFormIsShow: false,
      userGroupFormTitle: '',
      userGroupForm: {
        id: 0,
        name: '',
        resume: '',
        users: []
      },
      userGroupRule: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      },
      userGroup: {
        query: '',
        total: 1,
        limit: 15,
        current_page: 1,
        data: [],
        columns: [
          {
            title: '名称',
            align: 'center',
            minWidth: 110,
            render: (h, params) => {
              return h('div', params.row.team.name)
            }
          },
          {
            title: '备注',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              return h('div', params.row.team.resume)
            }
          },
          {
            title: '创建用户',
            key: 'creator_name',
            align: 'center',
            minWidth: 100
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 150,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.userGroupFormShow(true, params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.userGroupRemove(params.row)
                    }
                  }
                }, '删除')
              ])
            }
          }
        ]
      },

      // 告警用户列表
      AllUsersList: [],

      // 个人告警信息
      personalInfoForm: {
        email: '',
        phone: '',
        im: ''
      },
      personalInfoRule: {
        email: [
          { required: true, message: '邮箱是必填的', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    this.getTemplates()
    this.getAllHostGroup()
    this.getEndpoints()
    this.getAllTemplateList()
    // this.getMetricDefaultList()
    this.getAllUserGroupList()
    this.getAllUsersList()
  },
  methods: {
    // 策略模板
    getTemplates (value = 1) {
      let that = this
      that.template.current_page = value
      let params = {
        'limit': that.template.limit,
        'query': that.template.query,
        'page': that.template.current_page
      }
      mainRequest.getAlarmTemplate(params).then(res => {
        let result = res.data
        if (result.code === 200) {
          that.template.data = result.data
          that.template.total = result.total
        } else {
          that.$Notice.error({
            title: '获取策略模板列表失败！请求状态码:' + result.code,
            desc: result.msg
          })
        }
      }).catch(res => {
        that.template.current_page = 1
        that.template.total = 1
        that.template.data = []
        if (res.request) {
          that.$Notice.error({
            title: '获取策略模板列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getAllTemplateList () {
      mainRequest.getAllAlarmTemplate().then(res => {
        let result = res.data
        if (result.code !== 200) {
          this.templateAllList = []
        } else {
          this.templateAllList = result.data
        }
      })
    },
    templateSubmit (name) {
      let that = this
      this.$refs[name].validate((valid) => {
        if (valid) {
          mainRequest.changeAlarmTemplate(that.templateForm, that.templateForm.id).then(res => {
            let result = res.data
            if (result.code !== 200) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + result.code,
                desc: result.msg
              })
              return
            }
            that.templateForm.id = 0
            that.templateForm.name = ''
            that.templateForm.parent_id = 0
            that.templateFormIsShow = false
            that.$Notice.success({
              title: '操作成功！'
            })
            this.getAllTemplateList()
            that.getTemplates(this.template.current_page)
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        } else {
          that.$Notice.error({
            title: '请检查输入框！'
          })
        }
      })
    },
    templateRemove (row) {
      let that = this
      that.$Modal.confirm({
        title: '删除',
        content: '确定要删除这条「' + row.tpl_name + '」策略模板吗?',
        onOk: () => {
          mainRequest.deleteAlarmTemplate(row.id).then(res => {
            let result = res.data
            if (result.code === 200) {
              that.$Notice.success({
                title: '操作成功！'
              })
              that.getAllTemplateList()
              that.getTemplates(this.template.current_page)
            } else {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + result.code,
                desc: result.msg
              })
            }
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        }
      })
    },
    templateFormShow (status, row = {}) {
      let that = this
      that.templateFormIsShow = status
      if (status) {
        that.templateStrategyListIsShow = false
        that.templateStrategyFormIsShow = false
        that.templateActionIsShow = false
      }
      if (row.id) {
        that.templateFormTitle = '[策略模板：' + row.tpl_name + '] 编辑模板'
        that.templateForm.id = row.id
        that.templateForm.name = row.tpl_name
        that.templateForm.parent_id = row.parent_id
      } else {
        that.templateFormTitle = '新增策略模板'
        that.templateForm.id = 0
        that.templateForm.name = ''
        that.templateForm.parent_id = 0
      }
    },

    // 策略模板 -- 策略列表
    getTemplateStrategy (tplId) {
      let that = this
      let params = {
        'tpl_id': tplId
      }
      this.inheritTemplateList.data = []
      mainRequest.getAlarmStrategy(params).then(res => {
        let result = res.data
        if (result.code === 200) {
          that.templateStrategyList.data = result.data
        } else {
          that.$Notice.error({
            title: '获取策略列表失败！请求状态码:' + result.code,
            desc: result.msg
          })
        }
      }).catch(res => {
        that.template.data = []
        if (res.request) {
          that.$Notice.error({
            title: '获取策略列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
      if (this.showParentTemplateId) {
        mainRequest.detailAlarmTemplate(this.showParentTemplateId).then(res => {
          let result = res.data
          if (result.code === 200) {
            that.inheritTemplateList.data.push(result.data)
          }
        }).catch(res => {})
      }
    },
    templateStrategyListShow (status, row = {}) {
      let that = this
      if (status) {
        that.templateFormIsShow = false
        that.templateStrategyFormIsShow = false
        that.templateActionIsShow = false
      }
      that.templateStrategyListIsShow = status
      if (row.template) {
        that.templateStrategyForm.tpl_id = row.template.id
        that.templateStrategyListTitle = '策略模板：' + row.template.tpl_name
        this.showParentTemplateId = row.template.parent_id
        that.getTemplateStrategy(row.template.id)
        this.bindHostSelectCounterModalOpen()
      }
    },
    templateStrategyFormShow (status, row = {}) {
      let that = this
      that.templateStrategyListIsShow = !status
      that.templateStrategyFormIsShow = status
      if (row.id) {
        that.templateStrategyTitle = '[' + that.templateStrategyListTitle + '] 修改策略：' + row.id + ' - ' + row.metric
        that.templateStrategyForm.id = row.id
        that.templateStrategyForm.metric = row.metric
        that.templateStrategyForm.tags = row.tags
        that.templateStrategyForm.max_step = row.max_step
        that.templateStrategyForm.priority = row.priority
        that.templateStrategyForm.note = row.note
        that.templateStrategyForm.func = row.func
        that.templateStrategyForm.op = row.op
        that.templateStrategyForm.right_value = row.right_value
        that.templateStrategyForm.run_begin = row.run_begin
        that.templateStrategyForm.run_end = row.run_end
        that.templateStrategyForm.alarm_week = row.alarm_week
        that.templateStrategyForm.is_active = row.is_active
        if (row.priority === 1 || row.priority === 3 || row.priority === 5 || row.priority === 11) {
          this.alarm_style = [row.priority]
        } else if (row.priority === 4) {
          this.alarm_style = [1, 3]
        } else if (row.priority === 6) {
          this.alarm_style = [1, 5]
        } else if (row.priority === 8) {
          this.alarm_style = [3, 5]
        } else if (row.priority === 9) {
          this.alarm_style = [1, 3, 5]
        } else if (row.priority === 12) {
          this.alarm_style = [1, 11]
        } else if (row.priority === 14) {
          this.alarm_style = [3, 11]
        } else if (row.priority === 15) {
          this.alarm_style = [1, 3, 11]
        } else if (row.priority === 16) {
          this.alarm_style = [5, 11]
        } else if (row.priority === 17) {
          this.alarm_style = [1, 5, 11]
        } else if (row.priority === 19) {
          this.alarm_style = [3, 5, 11]
        } else if (row.priority === 20) {
          this.alarm_style = [1, 3, 5, 11]
        }
        if (that.templateStrategyForm.run_begin || that.templateStrategyForm.run_end || that.templateStrategyForm.alarm_week.length !== 7) {
          that.alarmIsAllTime = false
        } else {
          that.alarmIsAllTime = true
        }
      } else {
        that.templateStrategyTitle = '[' + that.templateStrategyListTitle + '] 添加策略'
        that.templateStrategyForm.id = 0
        that.templateStrategyForm.metric = ''
        that.templateStrategyForm.tags = ''
        that.templateStrategyForm.max_step = 3
        that.templateStrategyForm.priority = 0
        that.templateStrategyForm.note = ''
        that.templateStrategyForm.func = 'all(#3)'
        that.templateStrategyForm.op = '=='
        that.templateStrategyForm.right_value = '0'
        that.templateStrategyForm.run_begin = ''
        that.templateStrategyForm.run_end = ''
        that.templateStrategyForm.alarm_week = ['1', '2', '3', '4', '5', '6', '7']
        that.templateStrategyForm.is_active = true
        this.alarm_style = []
        that.alarmIsAllTime = true
      }
    },
    templateStrategySubmit (name) {
      let that = this
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (that.templateStrategyForm.max_step <= 0) {
            that.$Notice.error({
              title: '操作失败！',
              desc: '最大报警次数不能小于等于0'
            })
            return false
          }
          if (!that.alarmIsAllTime) {
            if (!that.templateStrategyForm.alarm_week.length) {
              that.$Notice.error({
                title: '请选择告警星期'
              })
              return false
            }
            // if (!that.templateStrategyForm.run_begin) {
            //   that.$Notice.error({
            //     title: '请选择告警开始时间'
            //   })
            //   return false
            // }
            // if (!that.templateStrategyForm.run_end) {
            //   that.$Notice.error({
            //     title: '请选择告警结束时间'
            //   })
            //   return false
            // }
          } else {
            that.templateStrategyForm.run_begin = ''
            that.templateStrategyForm.run_end = ''
            that.templateStrategyForm.alarm_week = ['1', '2', '3', '4', '5', '6', '7']
          }
          let priority = 0
          for (let v in this.alarm_style) {
            priority += this.alarm_style[v]
          }
          this.templateStrategyForm.priority = priority
          this.strategySubmitting = true
          mainRequest.changeAlarmStrategy(that.templateStrategyForm, that.templateStrategyForm.id).then(res => {
            this.strategySubmitting = false
            let result = res.data
            if (result.code !== 200) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + result.code,
                desc: result.msg
              })
              return false
            }
            that.getTemplateStrategy(that.templateStrategyForm.tpl_id)
            that.templateStrategyForm.id = 0
            that.templateStrategyForm.metric = ''
            that.templateStrategyForm.tags = ''
            that.templateStrategyForm.max_step = 3
            that.templateStrategyForm.priority = 0
            that.templateStrategyForm.note = ''
            that.templateStrategyForm.func = 'all(#3)'
            that.templateStrategyForm.op = '=='
            that.templateStrategyForm.right_value = '0'
            that.templateStrategyForm.run_begin = ''
            that.templateStrategyForm.run_end = ''
            that.templateStrategyForm.alarm_week = ['1', '2', '3', '4', '5', '6', '7']
            that.templateStrategyForm.is_active = true
            this.alarm_style = []
            that.templateStrategyFormIsShow = false
            that.templateStrategyListIsShow = true
            that.$Notice.success({
              title: '操作成功！'
            })
          }).catch(res => {
            this.strategySubmitting = false
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        } else {
          that.$Notice.error({
            title: '请检查输入框！'
          })
        }
      })
    },
    templateStrategyRemove (row) {
      let that = this
      that.$Modal.confirm({
        title: '删除',
        content: '确定要删除「' + row.id + ' - ' + row.metric + '」策略吗?',
        onOk: () => {
          mainRequest.deleteAlarmStrategy(row.id).then(res => {
            let result = res.data
            if (result.code === 200) {
              that.getTemplateStrategy(that.templateStrategyForm.tpl_id)
              that.$Notice.success({
                title: '操作成功！'
              })
              that.getTemplates(this.template.current_page)
            } else {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + result.code,
                desc: result.msg
              })
            }
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        }
      })
    },
    getMetricDefaultList () {
      mainRequest.getAlarmMetricDefaultList().then(res => {
        let result = res.data
        if (result.code !== 200) {
          this.metricDefaultList = []
        } else {
          this.metricDefaultList = result.data
        }
      })
    },

    // 策略模板 -- 告警动作
    getAllUserGroupList () {
      mainRequest.getAlarmAllUserGroupList().then(res => {
        let result = res.data
        if (result.code !== 200) {
          this.AllUserGroupList = []
        } else {
          this.AllUserGroupList = result.data
        }
      })
    },
    templateActionShow (status, row = {}) {
      let that = this
      that.templateActionIsShow = status
      that.templateStrategyListIsShow = false
      that.templateStrategyFormIsShow = false
      that.templateFormIsShow = false
      if (row.template) {
        that.templateActionTitle = '[策略模板：' + row.template.tpl_name + '] 告警动作'
        that.templateActionForm.tpl_id = row.template.id
        mainRequest.detailAlarmTemplate(row.template.id).then(res => {
          let result = res.data
          if (result.code === 200) {
            let actionData = result.data.action
            that.templateActionForm.id = actionData.id
            that.templateActionForm.uic = actionData.uic.split(',')
            that.templateActionForm.url = actionData.url
            that.templateActionForm.callback = trueOrFalseTransform[actionData.callback]
            that.templateActionForm.before_callback_sms = trueOrFalseTransform[actionData.before_callback_sms]
            that.templateActionForm.before_callback_mail = trueOrFalseTransform[actionData.before_callback_mail]
            that.templateActionForm.after_callback_sms = trueOrFalseTransform[actionData.after_callback_sms]
            that.templateActionForm.after_callback_mail = trueOrFalseTransform[actionData.after_callback_mail]
          }
        }).catch(res => {
          that.templateActionForm.id = 0
          that.templateActionForm.uic = []
          that.templateActionForm.url = ''
          that.templateActionForm.callback = false
          that.templateActionForm.before_callback_sms = false
          that.templateActionForm.before_callback_mail = false
          that.templateActionForm.after_callback_sms = false
          that.templateActionForm.after_callback_mail = false
          if (res.request) {
            that.$Notice.error({
              title: '获取告警动作失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      }
    },
    templateActionSubmit (name) {
      let that = this
      this.$refs[name].validate((valid) => {
        if (valid) {
          mainRequest.changeAlarmTemplateAction(that.templateActionForm, that.templateActionForm.id).then(res => {
            let result = res.data
            if (result.code !== 200) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + result.code,
                desc: result.msg
              })
              return
            }
            that.templateActionForm.id = 0
            that.templateActionForm.tpl_id = 0
            that.templateActionForm.uic = []
            that.templateActionForm.url = ''
            that.templateActionForm.callback = false
            that.templateActionForm.before_callback_sms = false
            that.templateActionForm.before_callback_mail = false
            that.templateActionForm.after_callback_sms = false
            that.templateActionForm.after_callback_mail = false
            that.templateActionIsShow = false
            that.$Notice.success({
              title: '操作成功！'
            })
            that.getTemplates(this.template.current_page)
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        } else {
          that.$Notice.error({
            title: '请检查输入框！'
          })
        }
      })
    },

    // 模板策略 -- 绑定设备组
    getAllHostGroup () {
      let that = this
      mainRequest.getAllAlarmAllHostGroup().then(res => {
        let result = res.data
        if (result.code === 200) {
          let data = []
          for (let i in result.data) {
            data.push({ 'key': result.data[i].id, 'label': result.data[i].grp_name })
          }
          that.templateHaveHostGroupData = data
        } else {
          that.$Notice.error({
            title: '获取所有设备组列表失败！请求状态码:' + result.code,
            desc: result.msg
          })
        }
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '获取所有设备组列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    templateHaveHostGroupChange (newTargetKeys) {
      this.templateHaveHostGroupTargetKeys = newTargetKeys
    },
    templateHaveHostGroupModalOk () {
      let that = this
      let reqData = {
        'template_id': that.templateHaveHostGroupTplId,
        'host_group_list': that.templateHaveHostGroupTargetKeys
      }
      mainRequest.AlarmTemplateHostGroupBind(reqData).then(res => {
        let result = res.data
        if (result.code !== 200) {
          that.$Notice.error({
            title: '操作失败！请求状态码:' + result.code,
            desc: result.msg
          })
          return
        }
        that.$Notice.success({
          title: '操作成功！'
        })
        that.templateHaveHostGroupModal = false
        that.templateHaveHostGroupTplId = 0
        that.templateHaveHostGroupTargetKeys = []
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    templateHaveHostGroupModalCancel () {
      this.templateHaveHostGroupTargetKeys = []
    },
    templateHaveHostGroup (template) {
      let templateId = template.id
      let that = this
      that.templateHaveHostGroupModal = true
      that.templateHaveHostGroupTplId = templateId
      that.templateHaveHostGroupModalTitle = '[策略模板：' + template.tpl_name + '] 绑定设备组'
      let params = { 'template_id': templateId }
      mainRequest.getAlarmAllUserGroupListByTemplateId(params).then(res => {
        let result = res.data
        that.templateHaveHostGroupTargetKeys = []
        if (result.code === 200) {
          for (let i in result.data) {
            that.templateHaveHostGroupTargetKeys.push(result.data[i].id)
          }
        }
      }).catch(res => {
        that.templateHaveHostGroupTargetKeys = []
        if (res.request) {
          that.$Notice.error({
            title: '获取告警用户组失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    bindHostSelectCounterModalOpen () {
      this.bindHostSelectCounterData = []
      let params = {
        tpl_id: this.templateStrategyForm.tpl_id
      }
      mainRequest.GetCounterByAlarmTemplateApi(params).then(res => {
        let result = res.data
        if (result.code === 200) {
          this.bindHostSelectCounterData = result.data
        }
      })
      // this.bindHostSelectCounterModal = true
    },
    bindHostSelectCounterChange (value) {
      this.templateStrategyForm.metric = value
      this.bindHostSelectCounterModal = false
    },

    // 告警设备组
    getHostGroups (value = 1) {
      let that = this
      that.hostGroup.current_page = value
      let params = {
        'limit': that.hostGroup.limit,
        'query': that.hostGroup.query,
        'page': that.hostGroup.current_page,
        'template_id': that.hostGroupBelongTemplate
      }
      mainRequest.getAlarmHostGroup(params).then(res => {
        let result = res.data
        if (result.code === 200) {
          that.hostGroup.data = result.data
          that.hostGroup.total = result.total
        } else {
          that.$Notice.error({
            title: '获取告警设备组失败！请求状态码:' + result.code,
            desc: result.msg
          })
        }
      }).catch(res => {
        that.hostGroup.current_page = 1
        that.hostGroup.total = 1
        that.hostGroup.data = []
        if (res.request) {
          that.$Notice.error({
            title: '获取告警设备组失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    hostGroupSubmit (name) {
      let that = this
      this.$refs[name].validate((valid) => {
        if (valid) {
          mainRequest.changeAlarmHostGroup(that.hostGroupForm, that.hostGroupForm.id).then(res => {
            let result = res.data
            if (result.code !== 200) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + result.code,
                desc: result.msg
              })
              return
            }
            that.hostGroupForm.id = 0
            that.hostGroupForm.name = ''
            that.hostGroupFormIsShow = false
            that.$Notice.success({
              title: '操作成功！'
            })
            that.getAllHostGroup()
            that.getHostGroups()
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        } else {
          that.$Notice.error({
            title: '请检查输入框！'
          })
        }
      })
    },
    hostGroupRemove (row) {
      let that = this
      that.$Modal.confirm({
        title: '删除',
        content: '确定要删除「' + row.grp_name + '」策略设备组吗?',
        onOk: () => {
          mainRequest.deleteAlarmHostGroup(row.id).then(res => {
            let result = res.data
            if (result.code === 200) {
              that.$Notice.success({
                title: '操作成功！'
              })
              that.getHostGroups()
            } else {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + result.code,
                desc: result.msg
              })
            }
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        }
      })
    },
    hostGroupFormShow (status, row = {}) {
      let that = this
      that.hostGroupFormIsShow = status
      if (row.id) {
        that.hostGroupFormTitle = '[设备组：' + row.grp_name + '] 编辑'
        that.hostGroupForm.id = row.id
        that.hostGroupForm.name = row.grp_name
      } else {
        that.hostGroupFormTitle = '新增策略设备组'
        that.hostGroupForm.id = 0
        that.hostGroupForm.name = ''
      }
    },

    // 告警设备组 -- 绑定设备
    getEndpoints () {
      let that = this
      mainRequest.getAllEndpoint().then(res => {
        let result = res.data
        that.hostGroupHaveHostData = []
        for (let i in result) {
          that.hostGroupHaveHostData.push({
            'key': result[i].endpoint,
            'label': result[i].endpoint
          })
        }
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '获取告警设备组失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    getHostsByHostGroupId (hostGroup) {
      let hostGroupId = hostGroup.id
      let that = this
      that.hostGroupHaveHostModal = true
      that.hostGroupHaveHostHGId = hostGroupId
      that.hostGroupHaveHostModalTitle = '[设备组：' + hostGroup.grp_name + '] 绑定设备'
      mainRequest.detailAlarmHostGroup(hostGroupId).then(res => {
        let result = res.data
        that.hostGroupHaveHostTargetKeys = []
        if (result.code === 200) {
          let data = result.data.hosts
          for (let i in data) {
            that.hostGroupHaveHostTargetKeys.push(data[i].hostname)
          }
        }
      }).catch(res => {
        that.hostGroupHaveHostTargetKeys = []
        if (res.request) {
          that.$Notice.error({
            title: '获取已绑定的设备组失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    hostGroupHaveHostChange (newTargetKeys) {
      this.hostGroupHaveHostTargetKeys = newTargetKeys
    },
    hostGroupHaveHostModalOk () {
      let that = this
      let reqData = {
        'host_group_id': that.hostGroupHaveHostHGId,
        'host_list': that.hostGroupHaveHostTargetKeys
      }
      mainRequest.AlarmHostGroupBindHostBind(reqData).then(res => {
        let result = res.data
        if (result.code !== 200) {
          that.$Notice.error({
            title: '操作失败！请求状态码:' + result.code,
            desc: result.msg
          })
          return
        }
        that.$Notice.success({
          title: '操作成功！'
        })
        that.hostGroupHaveHostModal = false
        that.hostGroupHaveHostHGId = 0
        that.hostGroupHaveHostTargetKeys = []
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    hostGroupHaveHostModalCancel () {
      this.hostGroupHaveHostTargetKeys = []
    },

    // 告警用户组
    getUserGroups (value = 1) {
      let that = this
      that.userGroup.current_page = value
      let params = {
        'limit': that.userGroup.limit,
        'query': that.userGroup.query,
        'page': that.userGroup.current_page
      }
      mainRequest.getAlarmUserGroup(params).then(res => {
        let result = res.data
        if (result.code === 200) {
          that.userGroup.data = result.data
          that.userGroup.total = result.total
        } else {
          that.$Notice.error({
            title: '获取告警用户组失败！请求状态码:' + result.code,
            desc: result.msg
          })
        }
      }).catch(res => {
        that.userGroup.current_page = 1
        that.userGroup.total = 1
        that.userGroup.data = []
        if (res.request) {
          that.$Notice.error({
            title: '获取告警用户组失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    userGroupSubmit (name) {
      let that = this
      this.$refs[name].validate((valid) => {
        if (valid) {
          mainRequest.changeAlarmUserGroup(that.userGroupForm, that.userGroupForm.id).then(res => {
            let result = res.data
            if (result.code !== 200) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + result.code,
                desc: result.msg
              })
              return
            }
            that.userGroupForm.id = 0
            that.userGroupForm.name = ''
            that.userGroupForm.resume = ''
            that.userGroupForm.users = []
            that.userGroupFormIsShow = false
            that.$Notice.success({
              title: '操作成功！'
            })
            that.getAllUserGroupList()
            that.getUserGroups()
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        } else {
          that.$Notice.error({
            title: '请检查输入框！'
          })
        }
      })
    },
    userGroupRemove (row) {
      let that = this
      that.$Modal.confirm({
        title: '删除',
        content: '确定要删除「' + row.team.name + '」告警用户组吗?',
        onOk: () => {
          mainRequest.deleteAlarmUserGroup(row.team.id).then(res => {
            let result = res.data
            if (result.code === 200) {
              that.$Notice.success({
                title: '操作成功！'
              })
              that.getUserGroups()
            } else {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + result.code,
                desc: result.msg
              })
            }
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        }
      })
    },
    userGroupFormShow (status, row = {}) {
      let that = this
      that.userGroupFormIsShow = status
      if (row.team) {
        that.userGroupFormTitle = '[用户组：' + row.team.name + '] 编辑'
        that.userGroupForm.id = row.team.id
        that.userGroupForm.name = row.team.name
        that.userGroupForm.resume = row.team.resume
        let m = []
        for (let i in row.users) {
          m.push(row.users[i].id)
        }
        that.userGroupForm.users = m
      } else {
        that.userGroupFormTitle = '新增告警用户组'
        that.userGroupForm.id = 0
        that.userGroupForm.name = ''
        that.userGroupForm.resume = ''
        that.userGroupForm.users = []
      }
    },

    // 告警用户
    getAllUsersList () {
      mainRequest.getAlarmAllUsersList().then(res => {
        let result = res.data
        if (result.code !== 200) {
          this.AllUsersList = []
        } else {
          this.AllUsersList = result.data
        }
      })
    },

    // 个人告警信息
    getPersonalInfo () {
      let that = this
      mainRequest.getAlarmPersonalInfo().then(res => {
        let result = res.data
        if (result.code !== 200) {
          that.$Notice.error({
            title: '获取个人告警信息失败！请求状态码:' + result.code,
            desc: result.msg
          })
          return
        }
        that.personalInfoForm.email = result.data.email
        that.personalInfoForm.phone = result.data.phone
        that.personalInfoForm.im = result.data.im
      }).catch(res => {
        if (res.request) {
          that.$Notice.error({
            title: '获取个人告警信息失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    personalInfoSubmit (name) {
      let that = this
      this.$refs[name].validate((valid) => {
        if (valid) {
          mainRequest.updateAlarmPersonalInfo(that.personalInfoForm).then(res => {
            let result = res.data
            if (result.code === 200) {
              that.$Notice.success({
                title: '操作成功！'
              })
              that.getUserGroups()
            } else {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + result.code,
                desc: result.msg
              })
            }
          }).catch(res => {
            if (res.request) {
              that.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            }
          })
        } else {
          that.$Notice.error({
            title: '请检查输入框！'
          })
        }
      })
    },

    // 切换标签
    handleTabClick (name) {
      let that = this
      that.tabs = name
      switch (name) {
        case 'tag_template':
          that.getTemplates()
          break
        case 'tag_hostgroup':
          that.getHostGroups()
          break
        case 'tag_usergroup':
          that.getUserGroups()
          break
        case 'tag_personal_info':
          that.getPersonalInfo()
          break
      }
    },

    // 激活策略
    activeStrategyAction (status, id) {
      let reqData = {
        is_active: status,
        strategy: id
      }
      this.activeStrategyLoading = true
      mainRequest.activeStrategyApi(reqData).then(res => {
        this.getTemplateStrategy(this.templateStrategyForm.tpl_id)
        this.activeStrategyLoading = false
        this.$Notice.success({
          title: '操作成功！'
        })
      }).catch(errO => {
        this.activeStrategyLoading = false
        if (errO.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + errO.request.status,
            desc: errO.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@media screen and (max-width:640px){
  .mob-w-auto{
      .ivu-form-item{
        width:auto;
        &:nth-of-type(3){
          padding-left:100px;
        }
      }
  }
}
</style>
